import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';

import { delay, map } from 'rxjs/operators';
import { Actions } from '../../actions';

import {
  CREATE_ADDITIONAL_ACCOUNT_SUCCESS,
  UPDATE_USER_SUCCESS,
} from '../../user/actions';
import { NoOp, ShowToastNotification } from '../action-creators';
import {
  CreateAdditionalAccountSuccess,
  UpdateUserSuccess,
} from '@webapp/store/user/action-creators';
import { UpdateArtistPresetsSuccess } from '@webapp/store/artist-presets/action-creators';
import { ReassignSplitsSuccess } from '@webapp/store/ownership/action-creators';
import { CreateInvitesSuccess } from '@webapp/store/invites/action-creators';
import { CREATE_INVITES_SUCCESS } from '@webapp/store/invites/actions';
import { REASSIGN_SPLITS_SUCCESS } from '@webapp/store/ownership/actions';
import { CreateArtistInviteSuccess } from '@webapp/store/artist/action-creators';
import { CREATE_ARTIST_INVITE_SUCCESS } from '@webapp/store/artist/actions';
import { UPDATE_ARTIST_PRESETS_SUCCESS } from '@webapp/store/artist-presets/actions';

export const ShowToastNotificationEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<
      Actions,
      | CreateAdditionalAccountSuccess
      | UpdateUserSuccess
      | CreateInvitesSuccess
      | CreateArtistInviteSuccess
      | ReassignSplitsSuccess
      | UpdateArtistPresetsSuccess
    >(
      CREATE_ADDITIONAL_ACCOUNT_SUCCESS,
      UPDATE_USER_SUCCESS,
      CREATE_INVITES_SUCCESS,
      CREATE_ARTIST_INVITE_SUCCESS,
      REASSIGN_SPLITS_SUCCESS,
      UPDATE_ARTIST_PRESETS_SUCCESS
    ),
    delay(1000),
    map((action) => {
      if (
        action.type === CREATE_ADDITIONAL_ACCOUNT_SUCCESS ||
        action.type === UPDATE_USER_SUCCESS ||
        action.type === UPDATE_ARTIST_PRESETS_SUCCESS
      ) {
        return new ShowToastNotification(
          'user_changes_saved',
          'COMMON.CHANGES.SAVED',
          'info'
        );
      }
      if (
        action.type === REASSIGN_SPLITS_SUCCESS &&
        action.showToastNotification
      ) {
        return new ShowToastNotification(
          'user_changes_saved',
          'COMMON.CHANGES.SAVED',
          'success'
        );
      }
      if (
        action.type === CREATE_INVITES_SUCCESS ||
        action.type === CREATE_ARTIST_INVITE_SUCCESS
      ) {
        return new ShowToastNotification(
          'invite_sent',
          'COMMON.INVITE.SENT',
          'success'
        );
      }
      return new NoOp();
    })
  );
